import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex items-center flex-wrap gap-1.5 text-sm text-foreground-500">
      <Link to="/" className="hover:text-primary-700 transition-colors whitespace-nowrap">
        首页
      </Link>
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
          <span className="w-3 h-3 flex items-center justify-center text-foreground-300">
            <i className="ri-arrow-right-s-line text-base"></i>
          </span>
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-700 transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium wf-line-clamp-2">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}